import * as EASY_CONNECTION_TRIGGERS from 'constants/easyConnectionTriggers';
import get from 'lodash/get';

function getTriggerOptions(trigger, easyConnectionData) {
  if (!easyConnectionData || !easyConnectionData.toDisplay) {
    return false;
  }

  switch (trigger) {
    case EASY_CONNECTION_TRIGGERS.NAME.triggerText:
      return get(easyConnectionData, 'customerName');
    case EASY_CONNECTION_TRIGGERS.CONNECT_WITH_CUSTOMER.triggerText:
      return get(easyConnectionData, 'connections', []);
    default:
      return null;
  }
}

export function findValidTriggersInMacroText(string = '', easyConnectionData) {
  return Object.values(EASY_CONNECTION_TRIGGERS)
    .reduce((acc, trigger) => {
      const triggerText = trigger.triggerText;
      const options = getTriggerOptions(triggerText, easyConnectionData);

      if (string.includes(triggerText)) {
        const data = { ...trigger, options };

        return [...acc, data];
      }

      return acc;
    }, [])
    .sort((a, b) => {
      // logic needs the triggers to be ordered as they appear in macro text
      const aIdx = string.indexOf(a.triggerText);
      const bIdx = string.indexOf(b.triggerText);

      return aIdx - bIdx;
    });
}

export function hasUnresolvedEasyConnections(string = '', easyConnectionData) {
  const activeTriggers = findValidTriggersInMacroText(string, easyConnectionData);

  return !!activeTriggers.length;
}

export function getActiveTriggersInTextMessage(string = '', easyConnectionData) {
  const activeTriggers = findValidTriggersInMacroText(string, easyConnectionData);

  return activeTriggers.reduce((acc, trigger) => {
    if (acc.length) {
      acc += ` and ${trigger.triggerText}`;
    } else {
      acc += trigger.triggerText;
    }

    return acc;
  }, '');
}
